import { useState, useEffect } from 'react';
import { missionApi } from '../../api/mission.api';
import { PageHeader, Skeleton } from '../../components/ui/index';
import LeafletRouteMap from '../../components/map/LeafletRouteMap';

export default function CurrentMapPage() {
  const [mapData, setMapData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    missionApi.getCurrentMap().then(r=>setMapData(r.data)).catch(()=>{}).finally(()=>setLoading(false));
  }, []);
  const hasRoute = Array.isArray(mapData?.lat) && mapData.lat.length > 0;
  return (
    <div className="fade-in">
      <PageHeader title="نقشه فعلی کارمندان"/>
      <div style={{background:'#fff',borderRadius:14,border:'1px solid rgba(35,58,122,0.1)',overflow:'hidden',minHeight:500}}>
        {loading?<Skeleton h={500} radius={0}/>
        :hasRoute?<LeafletRouteMap lat={mapData.lat} lng={mapData.lng} origin={mapData.origin} destination={mapData.destination}
            // get_current_map's distance is already in km (queryGetCurrentMap
            // divides by 1000 before returning) - LeafletRouteMap's own
            // label divides by 1000 again assuming meters, so convert back
            // up or every real distance displays as ~0.00.
            distance={mapData.distance * 1000} />
        :<div style={{display:'flex',alignItems:'center',justifyContent:'center',height:500,background:'#f8faff',flexDirection:'column',gap:12}}>
            <span style={{fontSize:48}}>🗺️</span>
            <p style={{fontSize:14,color:'#64748b',textAlign:'center'}}>در حال حاضر ماموریت فعالی برای نمایش وجود ندارد</p>
          </div>
        }
      </div>
    </div>
  );
}